<template>
    <div class="animated fadeIn mt-3 pt-3 pb-0 px-3">
        <b-row>
            <b-col order="1" order-lg="1" cols="12" :lg="hasAvailableModules ? '8' : '12'" class="pr-3 pr-md-0"
                   :class="[ hasAvailableModules ? 'pr-md-0' : 'pr-md-3' ]">
                <i-o-monitor v-if="showIOMonitor" class="mb-3"></i-o-monitor>

                <device-history-chart class="mb-3"></device-history-chart>

                <energy-production-chart v-if="parameters.p_1 && parameters.p_1.value == 2" class="mb-3"></energy-production-chart>

                <relays-active-chart class="mb-3"></relays-active-chart>

                <!--                <b-card class="mb-3 modules-container">-->
                <!--                    <vue-weather-component style="all: initial;" :enable-credits="true"></vue-weather-component>-->
                <!--                </b-card>-->
            </b-col>

            <b-col v-if="hasAvailableModules" order="2" order-lg="2" cols="12" lg="4">
                <b-row>
                    <template v-for="module in getAvailableModules">
                        <b-col class="mb-3" cols="12" md="12" lg="12" v-if="module.value == 'variant'">
                            <variant-module></variant-module>
                        </b-col>

                        <b-col class="mb-3" cols="12" md="12" lg="12" v-if="module.value == 1">
                            <thermostat-module :module-number="moduleNumber(module.id)"></thermostat-module>
                        </b-col>

                        <b-col class="mb-3" cols="12" md="12" lg="12" v-if="module.value == 2">
                            <recycle-module :module-number="moduleNumber(module.id)"></recycle-module>
                        </b-col>

                        <b-col class="mb-3" cols="12" md="12" lg="12" v-if="module.value == 3">
                            <on-off-module :module-number="moduleNumber(module.id)"></on-off-module>
                        </b-col>

                        <b-col class="mb-3" cols="12" md="12" lg="12" v-if="module.value == 'heatpump'">
                            <heat-pump-module></heat-pump-module>
                        </b-col>

                        <b-col class="mb-3" cols="12" md="12" lg="12" v-if="module.value == 'current-power'">
                            <current-power-module></current-power-module>
                        </b-col>

                        <b-col class="mb-3" cols="12" md="12" lg="12" v-if="module.value == 'energy-consumption'">
                            <energy-production-module></energy-production-module>
                        </b-col>

                    </template>
                </b-row>

            </b-col>
        </b-row>
    </div>
</template>

<script>
    import store from '@/store';
    import {mapGetters} from 'vuex';
    import IOMonitor from "../components/virtual-device/info/io-monitors/IOMonitor";
    import DeviceHistoryChart from '../components/virtual-device/info/DeviceHistoryChart';
    import RelaysActiveChart from '../components/virtual-device/info/RelaysActiveChart';
    import EnergyProductionChart from "../components/virtual-device/info/EnergyProductionChart";
    import VariantModule from "../components/virtual-device/info/modules/VariantModule";
    import ThermostatModule from "../components/virtual-device/info/modules/ThermostatModule";
    import RecycleModule from "../components/virtual-device/info/modules/RecycleModule";
    import OnOffModule from "../components/virtual-device/info/modules/OnOffModule";
    import HeatPumpModule from "../components/virtual-device/info/modules/HeatPumpModule";
    import CurrentPowerModule from "../components/virtual-device/info/modules/CurrentPowerModule";
    import EnergyProductionModule from "../components/virtual-device/info/modules/EnergyProductionModule";
    // import VueWeatherComponent from 'vue-weather-component';

    export default {
        name: "VirtualDeviceInfo",

        components: {
            DeviceHistoryChart,
            RelaysActiveChart,
            EnergyProductionChart,
            IOMonitor,
            VariantModule,
            ThermostatModule,
            RecycleModule,
            OnOffModule,
            HeatPumpModule,
            CurrentPowerModule,
            EnergyProductionModule
            // VueWeatherComponent
        },

        async beforeRouteEnter(to, from, next) {
            await store.dispatch('virtualDevice/fetchInfoViewData', to.params.id);
            next();
        },

        data() {
            return {
                deviceId: this.$route.params.id
            }
        },

        computed: {
            ...mapGetters({
                getUIVersion: 'virtualDevice/uiVersion',
                getUserPrivilegeLevel: 'virtualDevice/userPrivilege',
                getDeviceData: 'virtualDevice/deviceData',
                getParameters: 'virtualDevice/parameters'
            }),

            uiVersion() {
                return this.getUIVersion(this.$route.params.id);
            },

            userPrivilegeLevel() {
                return this.getUserPrivilegeLevel(this.$route.params.id);
            },

            parameters() {
                return this.getParameters(this.deviceId);
            },

            getAvailableModules() {
                let availableModules = [];

                if (this.userPrivilegeLevel > 1) {
                    if (this.parameters.p_1 && this.parameters.p_1.value != 1 && this.parameters.p_1.value != 6) {
                        availableModules.push({value: 'variant'});
                    }

                    if (this.parameters.p_78 && this.parameters.p_78.value != 0) availableModules.push(this.parameters.p_78);
                    if (this.parameters.p_81 && this.parameters.p_81.value != 0) availableModules.push(this.parameters.p_81);
                    if (this.parameters.p_84 && this.parameters.p_84.value != 0) availableModules.push(this.parameters.p_84);

                    if (this.parameters.p_1 && this.parameters.p_1.value === 6 || this.parameters.p_1.value === 7) {
                        availableModules.push({value: 'heatpump'});
                    }

                    if (this.parameters.p_1 && this.parameters.p_1.value === 2) {
                        availableModules.push({value: 'current-power'});
                        availableModules.push({value: 'energy-consumption'});
                    }
                }

                return availableModules;
            },

            hasAvailableModules() {
                return this.uiVersion === 'tdc_v3' && this.getAvailableModules.length > 0;
            },

            showIOMonitor: function () {
                let sr = this.getDeviceData(this.$route.params.id);

                return !(sr.sens_1 === null && sr.sens_2 === null && sr.sens_3 === null && sr.sens_4 === null && sr.r_1 === null && sr.r_2 === null && sr.r_3 === null);
            }
        },

        methods: {
            moduleNumber(moduleId) {
                if (moduleId == 78) return 1;
                else if (moduleId == 81) return 2;
                else if (moduleId == 84) return 3;
            }
        }
    }
</script>

<style scoped>

</style>